import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access"
)({
  loader: () => ({
    crumb: "Contextual Access",
  }),
});
